/**
 * Quick date-range shortcut chips. Each chip computes a from/to ISO date pair
 * and bubbles it via `onApply({from, to, label})`.
 *
 * Items can be customised; defaults cover the common Turkish accounting ranges.
 */
import React from "react";
import { Zap } from "lucide-react";

function _ymd(d) {
  const y = d.getFullYear();
  const m = String(d.getMonth() + 1).padStart(2, "0");
  const dd = String(d.getDate()).padStart(2, "0");
  return `${y}-${m}-${dd}`;
}

export function computeQuickRange(key) {
  const today = new Date();
  const start = new Date(today);
  switch (key) {
    case "today":
      return { from: _ymd(today), to: _ymd(today) };
    case "last7":
      start.setDate(today.getDate() - 6);
      return { from: _ymd(start), to: _ymd(today) };
    case "last30":
      start.setDate(today.getDate() - 29);
      return { from: _ymd(start), to: _ymd(today) };
    case "this_month": {
      const first = new Date(today.getFullYear(), today.getMonth(), 1);
      return { from: _ymd(first), to: _ymd(today) };
    }
    case "last_month": {
      const first = new Date(today.getFullYear(), today.getMonth() - 1, 1);
      const last  = new Date(today.getFullYear(), today.getMonth(), 0);
      return { from: _ymd(first), to: _ymd(last) };
    }
    case "this_year": {
      const first = new Date(today.getFullYear(), 0, 1);
      return { from: _ymd(first), to: _ymd(today) };
    }
    case "last_year": {
      const first = new Date(today.getFullYear() - 1, 0, 1);
      const last  = new Date(today.getFullYear() - 1, 11, 31);
      return { from: _ymd(first), to: _ymd(last) };
    }
    default:
      return { from: "", to: "" };
  }
}

const DEFAULT_ITEMS = [
  { k: "today",       l: "Bugün" },
  { k: "last7",       l: "Son 7 Gün" },
  { k: "last30",      l: "Son 30 Gün" },
  { k: "this_month",  l: "Bu Ay" },
  { k: "last_month",  l: "Geçen Ay" },
  { k: "this_year",   l: "Bu Yıl" },
];

export default function QuickDateFilters({ onApply, items = DEFAULT_ITEMS, label = "Hızlı Tarih", testPrefix = "quick" }) {
  const click = (k) => {
    const r = computeQuickRange(k);
    onApply({ ...r, key: k });
  };
  return (
    <div className="flex items-center gap-1.5 flex-wrap" data-testid={`${testPrefix}-filters`}>
      <div className="inline-flex items-center gap-1 text-[11px] font-bold uppercase tracking-wider text-slate-600">
        <Zap size={11} /> {label}
      </div>
      {items.map((it) => (
        <button
          key={it.k}
          type="button"
          onClick={() => click(it.k)}
          className="text-[11px] font-semibold px-2 py-0.5 rounded-full border border-slate-300 bg-white text-slate-700 hover:bg-indigo-600 hover:text-white hover:border-indigo-600 transition-colors"
          data-testid={`${testPrefix}-${it.k}`}
        >
          {it.l}
        </button>
      ))}
    </div>
  );
}
